import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import DeleteButton from "../Buttons/DeleteButton";
import EditButton from "../Buttons/EditButton";
import DateAndTimeChip from "../Chips/DateAndTimeChip";
import SmallClientChip from "../SmallClientChip";
import EditQuickNote from "./EditQuickNote";
import EditTherapyNote from "./EditTherapyNote";
import EditSupportStaffNote from "./EditSupportStaffNote";
import EditAftercareNote from "./EditAftercareNote";
import DeleteNote from "./DeleteNote";
import ViewNote from "./ViewNote";
import TypeNoteChip from "../Chips/TypeNoteChip";
import { useNavigate } from "react-router-dom";
import EditCBTNote from "./EditCBTNote";
import "./AftercareNoteContainerRedesign.css";
import "./SupportStaffNoteContainerRedesign.css";
import "./TherapyNoteContainerRedesign.css";
import "./QuickNoteContainerRedesign.css";

function NotesContainer(props) {
  //VARIABLES
  const styleLive = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 600,
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleEdit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleAftercareEdit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "min(900px, calc(100vw - 32px))",
    maxHeight: "88vh",
    borderRadius: 3,
    backgroundColor: "white",
    boxShadow: 24,
    overflow: "hidden",
  };

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 260,
    borderRadius: 2,
    bgcolor: "background.paper",
    /*border: "1px solid #000",*/
    boxShadow: 24,
    // p: 4,
  };

  //STATES
  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  const [shouldNavigate, setShouldNavigate] = React.useState(false);

  //FUNCTIONS
  const openEditModal = () => {
    setShowEditModal(true);
  };
  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
  };
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  const handleNavigate = () => {
    setShouldNavigate(true);
  };

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(`/client/${props.clientId}`, {
        state: props, // Passez l'objet client complet
      });
    }
  }, [shouldNavigate]);

  return (
    <div className="notes-wrapper">
      <Modal
        open={showEditModal}
        onClose={closeEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={
            props.noteType === "aftercareNote" ||
            props.noteType === "supportStaffNote" ||
            props.noteType === "therapyNote" ||
            props.noteType === "quickNote"
              ? styleAftercareEdit
              : styleEdit
          }
        >
          {props.noteType === "cbtNote" ? (
            <EditCBTNote
              noteId={props.noteId}
              sessionDateTime={props.sessionDateTime || props.effectiveDate}
              sessionNumber={props.sessionNumber}
              presentation={props.presentation}
              treatmentGoal={props.treatmentGoal}
              fileUrls={props.fileUrls}
              clientId={props.clientId}
              clientFirstName={props.clientFirstName}
              clientLastName={props.clientLastName}
              clientProfilePicture={props.clientProfilePicture}
              closemodal={closeEditModal}
            />
          ) : props.noteType === "therapyNote" ? (
            <EditTherapyNote
              note={props.noteContent}
              noteId={props.noteId}
              effectiveDate={props.effectiveDate}
              effectiveDateTime={props.effectiveDateTime}
              fileUrls={props.fileUrls}
              clientId={props.clientId}
              closemodal={closeEditModal}
            />
          ) : props.noteType === "aftercareNote" ? (
            <EditAftercareNote
              note={props.noteContent}
              noteId={props.noteId}
              effectiveDate={props.effectiveDate}
              effectiveDateTime={props.effectiveDateTime}
              fileUrls={props.fileUrls}
              clientId={props.clientId}
              closemodal={closeEditModal}
            />
          ) : props.noteType === "supportStaffNote" ? (
            <EditSupportStaffNote
              note={props.noteContent}
              noteId={props.noteId}
              effectiveDate={props.effectiveDate}
              effectiveDateTime={props.effectiveDateTime}
              fileUrls={props.fileUrls}
              clientId={props.clientId}
              closemodal={closeEditModal}
            />
          ) : (
            <EditQuickNote
              note={props.noteContent}
              noteId={props.noteId}
              typeOfNote={props.noteType}
              effectiveDate={props.effectiveDate}
              closemodal={closeEditModal}
            />
          )}
        </Box>
      </Modal>

      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDeleteModal}>
          <DeleteNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeDeleteModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <ViewNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeViewModal}
            fileUrls={props.fileUrls}
          />
        </Box>
      </Modal>
      {props.noteType === "aftercareNote" ? (
        <article className="aftercare-note-summary-card">
          <div className="aftercare-note-summary-top">
            <div className="aftercare-note-summary-chips">
              <DateAndTimeChip date={props.noteDate} />
              <DateAndTimeChip date={props.noteTime} />
              <TypeNoteChip noteType={props.noteType} />
            </div>

            <div className="aftercare-note-summary-actions">
              <EditButton handleOpen={openEditModal} />
              <DeleteButton handleOpen={openDeleteModal} />
            </div>
          </div>

          <div className="aftercare-note-summary-main">
            <button
              type="button"
              className="aftercare-note-client-button"
              onClick={handleNavigate}
            >
              <SmallClientChip
                firstName={props.clientFirstName}
                lastName={props.clientLastName}
                avatar="1"
                clientPic={props.clientPic}
              />
            </button>

            <div className="aftercare-note-summary-meta">
              <div className="aftercare-note-summary-meta-item">
                <span>Done by</span>
                <strong>{props.doneBy || "-"}</strong>
              </div>
              <div className="aftercare-note-summary-meta-item">
                <span>Created</span>
                <strong>{props.timeStamp || "-"}</strong>
              </div>
              <div className="aftercare-note-summary-meta-item">
                <span>Last modification</span>
                <strong>{props.lastModification || "-"}</strong>
              </div>
              <div className="aftercare-note-summary-meta-item">
                <span>Attachments</span>
                <strong>
                  {props.fileUrls?.length
                    ? props.fileUrls.map((file, index) => (
                        <React.Fragment key={`${file.url || file.name}-${index}`}>
                          {index > 0 && ", "}
                          <a href={file.url} target="_blank" rel="noreferrer">
                            {file.name || "File"}
                          </a>
                        </React.Fragment>
                      ))
                    : 0}
                </strong>
              </div>
            </div>
          </div>

          <div className="aftercare-note-summary-content">
            {props.noteContent || "No note content."}
          </div>
        </article>
      ) : props.noteType === "supportStaffNote" ? (
        <article className="support-staff-note-summary-card">
          <div className="support-staff-note-summary-top">
            <div className="support-staff-note-summary-chips">
              <DateAndTimeChip date={props.noteDate} />
              <DateAndTimeChip date={props.noteTime} />
              <TypeNoteChip noteType={props.noteType} />
            </div>

            <div className="support-staff-note-summary-actions">
              <EditButton handleOpen={openEditModal} />
              <DeleteButton handleOpen={openDeleteModal} />
            </div>
          </div>

          <div className="support-staff-note-summary-main">
            <button
              type="button"
              className="support-staff-note-client-button"
              onClick={handleNavigate}
            >
              <SmallClientChip
                firstName={props.clientFirstName}
                lastName={props.clientLastName}
                avatar="1"
                clientPic={props.clientPic}
              />
            </button>

            <div className="support-staff-note-summary-meta">
              <div className="support-staff-note-summary-meta-item">
                <span>Done by</span>
                <strong>{props.doneBy || "-"}</strong>
              </div>
              <div className="support-staff-note-summary-meta-item">
                <span>Created</span>
                <strong>{props.timeStamp || "-"}</strong>
              </div>
              <div className="support-staff-note-summary-meta-item">
                <span>Last modification</span>
                <strong>{props.lastModification || "-"}</strong>
              </div>
              <div className="support-staff-note-summary-meta-item">
                <span>Attachments</span>
                <strong>
                  {props.fileUrls?.length
                    ? props.fileUrls.map((file, index) => (
                        <React.Fragment key={`${file.url || file.name}-${index}`}>
                          {index > 0 && ", "}
                          <a href={file.url} target="_blank" rel="noreferrer">
                            {file.name || "File"}
                          </a>
                        </React.Fragment>
                      ))
                    : 0}
                </strong>
              </div>
            </div>
          </div>

          <div className="support-staff-note-summary-content">
            {props.noteContent || "No note content."}
          </div>
        </article>
      ) : props.noteType === "therapyNote" ? (
        <article className="therapy-note-summary-card">
          <div className="therapy-note-summary-top">
            <div className="therapy-note-summary-chips">
              <DateAndTimeChip date={props.noteDate} />
              <DateAndTimeChip date={props.noteTime} />
              <TypeNoteChip noteType={props.noteType} />
            </div>

            <div className="therapy-note-summary-actions">
              <EditButton handleOpen={openEditModal} />
              <DeleteButton handleOpen={openDeleteModal} />
            </div>
          </div>

          <div className="therapy-note-summary-main">
            <button
              type="button"
              className="therapy-note-client-button"
              onClick={handleNavigate}
            >
              <SmallClientChip
                firstName={props.clientFirstName}
                lastName={props.clientLastName}
                avatar="1"
                clientPic={props.clientPic}
              />
            </button>

            <div className="therapy-note-summary-meta">
              <div className="therapy-note-summary-meta-item">
                <span>Done by</span>
                <strong>{props.doneBy || "-"}</strong>
              </div>
              <div className="therapy-note-summary-meta-item">
                <span>Created</span>
                <strong>{props.timeStamp || "-"}</strong>
              </div>
              <div className="therapy-note-summary-meta-item">
                <span>Last modification</span>
                <strong>{props.lastModification || "-"}</strong>
              </div>
              <div className="therapy-note-summary-meta-item">
                <span>Attachments</span>
                <strong>
                  {props.fileUrls?.length
                    ? props.fileUrls.map((file, index) => (
                        <React.Fragment key={`${file.url || file.name}-${index}`}>
                          {index > 0 && ", "}
                          <a href={file.url} target="_blank" rel="noreferrer">
                            {file.name || "File"}
                          </a>
                        </React.Fragment>
                      ))
                    : 0}
                </strong>
              </div>
            </div>
          </div>

          <div className="therapy-note-summary-content">
            {props.noteContent || "No note content."}
          </div>
        </article>
      ) : props.noteType === "quickNote" ? (
        <article className="quick-note-summary-card">
          <div className="quick-note-summary-top">
            <div className="quick-note-summary-chips">
              <DateAndTimeChip date={props.noteDate} />
              <DateAndTimeChip date={props.noteTime} />
              <TypeNoteChip noteType={props.noteType} />
            </div>

            <div className="quick-note-summary-actions">
              <EditButton handleOpen={openEditModal} />
              <DeleteButton handleOpen={openDeleteModal} />
            </div>
          </div>

          <div className="quick-note-summary-main">
            <button
              type="button"
              className="quick-note-client-button"
              onClick={handleNavigate}
            >
              <SmallClientChip
                firstName={props.clientFirstName}
                lastName={props.clientLastName}
                avatar="1"
                clientPic={props.clientPic}
              />
            </button>

            <div className="quick-note-summary-meta">
              <div className="quick-note-summary-meta-item">
                <span>Done by</span>
                <strong>{props.doneBy || "-"}</strong>
              </div>
              <div className="quick-note-summary-meta-item">
                <span>Created</span>
                <strong>{props.timeStamp || "-"}</strong>
              </div>
              <div className="quick-note-summary-meta-item">
                <span>Last modification</span>
                <strong>{props.lastModification || "-"}</strong>
              </div>
            </div>
          </div>

          <div className="quick-note-summary-content">
            {props.noteContent || "No note content."}
          </div>
        </article>
      ) : (
        <div
          className="note-container"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            justifyContent: "flex-start",
            alignContent: "flex-start",
            alignItems: "flex-start",
            paddingLeft: "20px",
            height: "auto",
            paddingBottom: "10px",
            paddingRight: "10px",
            width: "100%",
          }}
        >
          <div
            className="note-container-block-1"
            style={{
              width: "auto",
              gap: "10px",
              height: "auto",
              flexDirection: "row",
            }}
          >
            <DateAndTimeChip date={props.noteDate} />
            <DateAndTimeChip date={props.noteTime} />
            <TypeNoteChip noteType={props.noteType} />
          </div>
          {/* <div className="note-container-block-2" style={{ width: "45px" }}>
            <img src={connector} height="300" />
          </div> */}
          <div className="note-container-block-3" style={{ width: "100%" }}>
            <div className="note-container-line-1">
              <div
                className="note-container-line1-block1 centre-block"
                onClick={handleNavigate}
                style={{ cursor: "pointer" }}
              >
                <SmallClientChip
                  firstName={props.clientFirstName}
                  lastName={props.clientLastName}
                  avatar="1"
                  clientPic={props.clientPic}
                />
              </div>
              <div className="note-container-line1-block1bis left-block">
                <div className="title-cell-container">Done by:</div>
                <div className="content-cell-container">{props.doneBy}</div>
              </div>
              <div className="note-container-line1-block2 left-block">
                <div className="title-cell-container">Timestamp:</div>
                <div className="content-cell-container">
                  {props.timeStamp}
                </div>{" "}
                <span
                  style={{ fontSize: "10px", textAlign: "left", width: "100%" }}
                >
                  {props.lastModification &&
                    `(Last modification: ${props.lastModification})`}
                </span>
              </div>
              <div className="note-container-line1-block2 centre-block2">
                <div className="sub-block-2">
                  <EditButton handleOpen={openEditModal} />
                  <DeleteButton handleOpen={openDeleteModal} />
                </div>
              </div>
            </div>
            <div
              className="note-container-line-2"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {props.noteContent}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default NotesContainer;
